<template>
  <div class="bg scroll" @scroll="scrollEvent">
    <!-- <PostWall /> -->
    <loading v-if="isLoading" />
    <NavBar else />
    <div class="post-wall pc-views">
      <!-- <div><img src="@/assets/img/friendGroupLogo.png" alt="" srcset="" /></div> -->
      <AddPostBtn v-if="this.$route.name !== 'FriendPost' && !getIsSetSessionWrong && !isLogin"></AddPostBtn>
      <!-- <UserCard></UserCard> -->
      <PostWallCard v-for="item in getPostWallData" :key="item.Id" :postData="item"></PostWallCard>
      <!-- 無動態時/例外發生時的 UI -->
      <ExceptionWall></ExceptionWall>
    </div>
    <Occlude v-if="isLogin" />
    <transition name="fade">
      <Common v-if="isOpenWindow" />
    </transition>
  </div>
</template>

<script>
import loading from '@/components/Common/Loading';
import Common from '@/components/Common/Modal';
import Occlude from '@/components/Occlude/Occlude';
import Register from '@/components/Register/Register';
import Login from '@/components/Login/Login';
import NavBar from '@/components/LayOut/NavBar';
import UserCard from '@/components/LayOut/UserCard';
import PostWall from '@/views/PostWall';
import AddPostBtn from '@/components/PostWall/AddPostBtn';
import PostWallCard from '@/components/PostWall/PostWallCard/PostWallCard';
import ExceptionWall from '@/components/PostWall/ExceptionWall';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
export default {
  name: 'Home',
  components: {
    PostWall,
    NavBar,
    Login,
    Register,
    Occlude,
    Common,
    AddPostBtn,
    PostWallCard,
    ExceptionWall,
    UserCard,
    loading
  },
  mounted() {
    if (this.getIsSetSession) {
      this.getApiPostWallData();
    }
  },
  watch: {
    // 監聽若 isSetSession 存入狀況變動要觸發取得貼文牆資料
    isSetSession: function() {
      this.getApiPostWallData();
      this.SET_LOGIN_STATUS(false);
    }
  },
  computed: {
    ...mapState(['isOpenWindow', 'isOpenRegister', 'setSessionStatus', 'isLogin', 'showModal']),
    ...mapState('thirdPartyLoginModule', ['isLoading']),
    ...mapGetters('PostWallModule', ['getPostWallData', 'getPostWallLoadStatus']),
    ...mapGetters(['getIsSetSession', 'getToken', 'getIsSetSessionWrong']),
    // 取得session 是否已存入
    isSetSession() {
      return this.getIsSetSession;
    }
  },
  methods: {
    ...mapActions('PostWallModule', ['getApiPostWallData']),
    ...mapMutations(['SET_LOGIN_STATUS', 'SET_USER_INFO']),
    scrollEvent(e) {
      if (e.srcElement.scrollTop + e.srcElement.offsetHeight > e.srcElement.scrollHeight - 2500) {
        if (this.getPostWallLoadStatus) {
          // 載入下一頁貼文牆貼文資料
          this.getApiPostWallData();
        }
      }
    }
  },
  created() {
    this.getApiPostWallData();
    const localStorageCheck = localStorage.getItem('laleToken');
    // 重新整理時判斷是否顯示遮擋塊
    if (localStorageCheck != null) {
      this.SET_LOGIN_STATUS(false);
    } else {
      this.SET_LOGIN_STATUS(true);
    }
  }
};
</script>

<style scoped lang="scss">
.scroll {
  height: 100% !important;
}

.post-wall {
  background-color: $LaleBg;
}

.scroll-div {
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
}

@media (min-width: 768px) {
  .post-wall-card {
    padding: 18px;
    padding-bottom: 0;
    background-color: #fff;
    margin-bottom: 12px;
    border: 1px solid #cecccc;
    border-radius: 10px;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  }
  .pc-views {
    width: 45%;
    // padding: 50px;
    margin: 0 auto;
    overflow: auto;
    margin-top: 20px;
    background-color: #e5e5e5;
    scrollbar-width: thin;
  }
  .PcViews::-webkit-scrollbar {
    width: 10px;
  }
  .PcViews::-webkit-scrollbar-track {
    box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.3);
  }

  .PcViews::-webkit-scrollbar-thumb {
    background-color: white;
    border: 1px solid slategrey;
    border-radius: 25px;
  }
}
.bg {
  height: 100%;
  width: 100%;
  background-color: #e5e5e5;
  // overflow: hidden;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

// @media (max-width: 768px) {
//   .bg {
//     height: 100%;
//     overflow: none;
//   }
// }
</style>
